import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Snowflake, Check } from 'lucide-react';
import { trackAddToCart } from '../../lib/pixel';
const SHOPIFY_URL = 'https://vitaliaguides.com/cart/add?id=47309581353123&quantity=1';
export function FinalCTA() {
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = SHOPIFY_URL;
  };
  return <Section id="pricing" className="bg-gradient-to-b from-brand-ice to-[#F8F5F0]" data-id="element-27">
      <div className="text-center max-w-2xl mx-auto" data-id="element-28">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-white border border-brand-slate-200 shadow-sm mb-6 md:mb-8" data-id="element-29">
          <Snowflake className="w-4 h-4 text-brand-sky" data-id="element-30" />
          <span className="text-xs md:text-sm font-medium text-brand-slate-700" data-id="element-31">
            Precio de lanzamiento
          </span>
        </div>

        <h2 className="text-2xl md:text-5xl font-bold text-brand-slate-900 mb-4 md:mb-6" data-id="element-32">
          180 recetas para tu freezer
        </h2>

        <p className="text-base md:text-lg text-brand-slate-600 mb-6 md:mb-8" data-id="element-33">
          6 kits completos en PDF. Elegí tu estilo y empezá a cocinar por
          tandas.
        </p>

        <div className="bg-white p-6 md:p-8 rounded-2xl md:rounded-3xl border border-brand-slate-200 shadow-xl mb-6 md:mb-8" data-id="element-34">
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-35">
            <span className="text-brand-slate-400 line-through text-xl md:text-2xl" data-id="element-36">
              ARS 29.999
            </span>
          </div>
          <div className="text-4xl md:text-6xl font-bold text-brand-slate-900 mb-2" data-id="element-37">
            ARS 9.999
          </div>
          <p className="text-sm text-brand-slate-500 mb-5 md:mb-6" data-id="element-38">
            Pago único • Acceso de por vida
          </p>

          <Button size="lg" fullWidth onClick={handleBuyClick} className="text-base md:text-lg mb-5 md:mb-6" data-id="element-39">
            Quiero el Pack 6 Kits
          </Button>

          <div className="flex flex-col md:flex-row flex-wrap justify-center gap-2.5 md:gap-4 text-xs md:text-sm text-brand-slate-600" data-id="element-40">
            <div className="flex items-center justify-center gap-2" data-id="element-41">
              <Check className="w-4 h-4 text-brand-sky" data-id="element-42" />
              Descarga inmediata
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-43">
              <Check className="w-4 h-4 text-brand-sky" data-id="element-44" />
              Garantía 7 días
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-45">
              <Check className="w-4 h-4 text-brand-sky" data-id="element-46" />
              Pago seguro
            </div>
          </div>
        </div>
      </div>
    </Section>;
}